<div class="dialog-body">
  <h2>Select Network</h2>

  <mat-form-field appearance="fill" style="width:100%; margin-top:12px;">
    <mat-label>Network</mat-label>
    <mat-select [(ngModel)]="network" panelClass="network-select-panel">
      <mat-option *ngFor="let opt of options" [value]="opt.value">
        {{ opt.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div style="display:flex; gap:12px; justify-content:flex-end; margin-top:20px;">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="confirm()" [disabled]="!network">
      Select Network
    </button>
  </div>
</div>
